import clsx from "clsx";
import { FC } from "react";
import { Link } from "react-router-dom";
import { priceFormatter } from "rujira.js";
import {
  AssetLabel,
  IconDenom,
  Icons,
  nFormatter,
  useTranslation,
} from "rujira.ui";

import { MarketsItemFragment$data } from "../__generated__/MarketsItemFragment.graphql";

const Change: FC<{ change: bigint }> = ({ change }) => (
  <span
    className={clsx("pair-row__change mono", {
      "color-teal": change > 0n,
      "color-red": change < 0n,
      "color-grey": change === 0n,
    })}>
    {change > 0n ? "+" : ""}
    {(Number(change) / 10 ** 10).toLocaleDecimal(2)}%
  </span>
);

export const PairRow: FC<{
  pair: MarketsItemFragment$data;
  url: string;
  favorite: boolean;
  onToggleFavorite: () => void;
  onNavigate?: () => void;
}> = ({ pair, url, favorite, onToggleFavorite, onNavigate }) => {
  const { t } = useTranslation();

  return (
    <li className="pair-row">
      <button
        type="button"
        className="pair-row__favorite transparent color-grey pointer"
        aria-pressed={favorite}
        aria-label={t("favorite")}
        onClick={onToggleFavorite}>
        {favorite ? (
          <Icons.StarSolid className="w-2 h-2" />
        ) : (
          <Icons.Star className="w-2 h-2" />
        )}
      </button>
      <Link
        to={url}
        relative="path"
        state={{ pairId: pair.id }}
        onClick={onNavigate}
        className="pair-row__body no-underline color-white">
        <span className="lp pair-row__icons">
          <IconDenom denom={pair.assetBase.metadata.symbol} />
          <IconDenom denom={pair.assetQuote.metadata.symbol} />
        </span>
        <span className="pair-row__pair">
          <span className="pair-row__name">
            <AssetLabel
              asset={pair.assetBase}
              Container={({ children }) => (
                <small className="color-grey fs-11">{children}</small>
              )}
            />
            <span className="color-grey ml-0.5">
              <AssetLabel
                asset={pair.assetQuote}
                Container={({ children }) => (
                  <small className="color-grey fs-11">{children}</small>
                )}
              />
            </span>
          </span>
          <span className="pair-row__volume mono">
            ${nFormatter(BigInt(pair.summary?.volumeUsd || 0), 2, 8)}
          </span>
        </span>
        <span className="pair-row__values">
          <span className="pair-row__last condensed">
            {priceFormatter(BigInt(pair.summary?.last || 0))}
            <small className="color-grey fs-11 ml-0.5">
              {pair.assetQuote.metadata.symbol}
            </small>
          </span>
          <Change change={BigInt(pair.summary?.change || 0)} />
        </span>
      </Link>
    </li>
  );
};
